import { get } from 'lodash'

import { Services, regExp } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'
import consents from '@/components/services/registration/consents'
import password from '@/components/services/users/form/basic/password'

function renderUsernameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.username,
        label: this.getTranslate(`${Services.registration}.labels.username`),
        hint: this.getTranslate(`${Services.registration}.hints.username`),
        error: this.errors.username || this.usernameValidation,
        name: 'username',
        dense: true,
        autofocus: true,
        required: true,
        tabindex: 1,
        mask: regExp.usernameSoftForRegistration
      },
      on: {
        input: event => {
          this.proxy.username = event
        }
      }
    }
  )
}
function renderPasswordField(h) {
  return h(
    password,
    {
      props: {
        value: this.proxy.password,
        isRegistration: true
      },
      on: {
        input: event => {
          this.proxy.password = event
        }
      }
    }
  )
}

function renderFirstNameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.data.firstName,
        label: this.getTranslate(`${Services.registration}.labels.firstName`),
        name: 'firstName',
        error: get(this.errors, 'data.firstName'),
        dense: true,
        details: false,
        required: true,
        tabindex: 3,
        mask: regExp.safeName
      },
      on: {
        input: event => {
          this.proxy.data.firstName = event
        }
      }
    }
  )
}
function renderLastNameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.data.lastName,
        label: this.getTranslate(`${Services.registration}.labels.lastName`),
        name: 'lastName',
        error: get(this.errors, 'data.lastName'),
        dense: true,
        details: false,
        tabindex: 3,
        mask: regExp.safeName
      },
      on: {
        input: event => {
          this.proxy.data.lastName = event
        }
      }
    }
  )
}
function renderEmailField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.data.email,
        label: this.getTranslate(`${Services.registration}.labels.email`),
        hint: this.getTranslate(`${Services.registration}.hints.email`),
        name: 'email',
        type: 'email',
        error: get(this.errors, 'data.email') || this.emailValidation,
        dense: true,
        required: true,
        tabindex: 4
      },
      on: {
        input: event => {
          this.proxy.data.email = event
        }
      }
    }
  )
}
function renderEmailInfoButton(h) {
  return h(
    button,
    {
      props: {
        icon: icons.help_outline,
        mode: buttonModes.flat
      },
      on: {
        click: () => {
          this.showEmailDescriptionDialog = true
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderEmailDialog.call(this, h)
        }
      }
    }
  )
}
function renderEmailDialogBody(h) {
  return h(
    'div',
    {
      class: 'pa-3',
      domProps: { innerHTML: this.getTranslate('registration.contents.email') }
    }
  )
}
function renderEmailDialogFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.showEmailDescriptionDialog = false
            }
          }
        }
      )
    ]
  )
}
function renderEmailDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`${Services.registration}.labels.email`),
        value: this.showEmailDescriptionDialog,
        maxWidth: 550
      },
      on: {
        input: event => {
          this.showEmailDescriptionDialog = event
        }
      }
    },
    [
      renderEmailDialogBody.call(this, h),
      renderEmailDialogFooter.call(this, h)
    ]
  )
}
function renderEmailFieldRow(h) {
  return h(
    'div',
    {
      class: `${Services.registration}-form__email`
    },
    [
      renderEmailField.call(this, h),
      renderEmailInfoButton.call(this, h)
    ]
  )
}
function renderPhoneField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.data.phone,
        label: this.getTranslate(`${Services.registration}.labels.phone`),
        hint: this.getTranslate(`${Services.registration}.hints.phone`),
        name: 'phone',
        type: 'tel',
        error: get(this.errors, 'data.phone') || this.phoneValidation,
        dense: true,
        details: false,
        required: true,
        tabindex: 5
      },
      on: {
        input: event => {
          this.proxy.data.phone = event
        }
      }
    }
  )
}

function renderUsedReferralCode(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.data.meta.usedReferralCode,
        label: this.getTranslate(`${Services.registration}.labels.usedReferralCode`),
        name: 'usedReferralCode',
        error: get(this.errors, 'data.meta.usedReferralCode'),
        dense: true,
        details: false,
        tabindex: 6
      },
      on: {
        input: event => {
          this.proxy.data.meta.usedReferralCode = event
        }
      }
    }
  )
}

function renderConsents(h) {
  return h(
    consents,
    {
      on: {
        validation: event => {
          this.consentsValidation = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: `${Services.registration}-form`,
      props: { autocomplete: 'off' }
    },
    [
      renderUsernameField.call(this, h),
      renderPasswordField.call(this, h),

      h('div'),

      renderFirstNameField.call(this, h),
      renderLastNameField.call(this, h),
      renderEmailFieldRow.call(this, h),
      renderPhoneField.call(this, h),

      h('div'),

      renderUsedReferralCode.call(this, h),
      renderConsents.call(this, h)
    ]
  )
}
